import L from "leaflet";
import { ICON_CONFIGS } from "./iconConfig";

export class IconFactory {
  static createIcon(type) {
    const config = ICON_CONFIGS[type];
    if (!config) {
      throw new Error(`Invalid icon type: ${type}`);
    }
    return L.icon(config);
  }

  static createMarker(latLng, type, options = {}) {
    const icon = this.createIcon(type);
    return L.marker(latLng, { icon, ...options });
  }

  // 在 IconFactory 中添加更详细的错误处理
  static createIcon(type) {
    const config = ICON_CONFIGS[type];
    if (!config) {
      console.error(
        `Invalid icon type: ${type}, available types:`,
        Object.keys(ICON_CONFIGS)
      );
      throw new Error(`Invalid icon type: ${type}`);
    }
    if (!config.iconUrl) {
      console.error(`Missing iconUrl for type: ${type}`);
      throw new Error(`Missing iconUrl for type: ${type}`);
    }
    try {
      return L.icon(config);
    } catch (error) {
      console.error(`Error creating icon for type ${type}:`, error);
      throw error;
    }
  }
}
